export default __webpack_public_path__ + "static/media/sad_rabbit.cc2ece35.jpg";